import { getUser } from 'apputil/user';

export const isAuthenticated = () => {
  const user = getUser();
  return !!user;
};
